@if (label) {
  <a class="atmos-text-link" [routerLink]="route" [queryParams]="queryParams">{{label}}</a>
}
